module.exports = __webpack_public_path__ + "static/img/duty-cycle-tradeoff.6e81124.png";